import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { storage as mmkv } from './mmkv-store';
const storage = {
    getItem: (key) => mmkv.getString(key) || null,
    setItem: (key, value) => mmkv.set(key, value),
    removeItem: (key) => mmkv.delete(key),
};
export const usePublicProgressStateStore = create()(persist((set) => ({
    progress: [],
    setProgress: (progress) => set((_state) => ({
        progress,
    })),
}), {
    name: 'public-progress-storage',
    storage: createJSONStorage(() => storage),
}));
//# sourceMappingURL=usePublicProgressStateStore.js.map